import moment from 'moment';

import { DatesIntervalEditorsState } from '../typings/datesInterval';

export const CHANGE_START_DATE_FOR_DATES_INTERVAL_EDITOR = 'CHANGE_START_DATE_FOR_DATES_INTERVAL_EDITOR';
export type CHANGE_START_DATE_FOR_DATES_INTERVAL_EDITOR = typeof CHANGE_START_DATE_FOR_DATES_INTERVAL_EDITOR;

export interface ChangeStartDateForDatesIntervalEditor {
    type: CHANGE_START_DATE_FOR_DATES_INTERVAL_EDITOR;
    editorId: string;
    date: moment.Moment;
}

export function changeStartDateForDatesIntervalEditor(
    editorId: string,
    date: moment.Moment
): ChangeStartDateForDatesIntervalEditor {
    return {
        type: CHANGE_START_DATE_FOR_DATES_INTERVAL_EDITOR,
        editorId,
        date
    };
}

export const CHANGE_END_DATE_FOR_DATES_INTERVAL_EDITOR = 'CHANGE_END_DATE_FOR_DATES_INTERVAL_EDITOR';
export type CHANGE_END_DATE_FOR_DATES_INTERVAL_EDITOR = typeof CHANGE_END_DATE_FOR_DATES_INTERVAL_EDITOR;

export interface ChangeEndDateForDatesIntervalEditor {
    type: CHANGE_END_DATE_FOR_DATES_INTERVAL_EDITOR;
    editorId: string;
    date: moment.Moment;
}

export function changeEndDateForDatesIntervalEditor(
    editorId: string,
    date: moment.Moment
): ChangeEndDateForDatesIntervalEditor {
    return {
        type: CHANGE_END_DATE_FOR_DATES_INTERVAL_EDITOR,
        editorId,
        date
    };
}

export const CHANGE_START_TIME_FOR_DATES_INTERVAL_EDITOR = 'CHANGE_START_TIME_FOR_DATES_INTERVAL_EDITOR';
export type CHANGE_START_TIME_FOR_DATES_INTERVAL_EDITOR = typeof CHANGE_START_TIME_FOR_DATES_INTERVAL_EDITOR;

export interface ChangeStartTimeForDatesIntervalEditor {
    type: CHANGE_START_TIME_FOR_DATES_INTERVAL_EDITOR;
    editorId: string;
    time: string;
}

export function changeStartTimeForDatesIntervalEditor(
    editorId: string,
    time: string
): ChangeStartTimeForDatesIntervalEditor {
    return {
        type: CHANGE_START_TIME_FOR_DATES_INTERVAL_EDITOR,
        editorId,
        time
    };
}

export const CHANGE_END_TIME_FOR_DATES_INTERVAL_EDITOR = 'CHANGE_END_TIME_FOR_DATES_INTERVAL_EDITOR';
export type CHANGE_END_TIME_FOR_DATES_INTERVAL_EDITOR = typeof CHANGE_END_TIME_FOR_DATES_INTERVAL_EDITOR;

export interface ChangeEndTimeForDatesIntervalEditor {
    type: CHANGE_END_TIME_FOR_DATES_INTERVAL_EDITOR;
    editorId: string;
    time: string;
}

export function changeEndTimeForDatesIntervalEditor(
    editorId: string,
    time: string
): ChangeEndTimeForDatesIntervalEditor {
    return {
        type: CHANGE_END_TIME_FOR_DATES_INTERVAL_EDITOR,
        editorId,
        time
    };
}

export const ADD_END_DATE_FOR_DATES_INTERVAL_EDITOR = 'ADD_END_DATE_FOR_DATES_INTERVAL_EDITOR';
export type ADD_END_DATE_FOR_DATES_INTERVAL_EDITOR = typeof ADD_END_DATE_FOR_DATES_INTERVAL_EDITOR;

export interface AddEndDateForDatesIntervalEditor {
    type: ADD_END_DATE_FOR_DATES_INTERVAL_EDITOR;
    editorId: string;
}

export function addEndDateForDatesIntervalEditor(editorId: string): AddEndDateForDatesIntervalEditor {
    return {
        type: ADD_END_DATE_FOR_DATES_INTERVAL_EDITOR,
        editorId
    };
}

export const DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR = 'DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR';
export type DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR = typeof DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR;

export interface DeleteEndDateForDatesIntervalEditor {
    type: DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR;
    editorId: string;
}

export function deleteEndDateForDatesIntervalEditor(editorId: string): DeleteEndDateForDatesIntervalEditor {
    return {
        type: DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR,
        editorId
    };
}

export const ON_DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR = 'ON_DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR';
export type ON_DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR = typeof ON_DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR;

export interface OnDeleteEndDateForDatesIntervalEditor {
    type: ON_DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR;
    editorId: string;
    onRemoveEndDate?: () => void;
    showMessage?: boolean;
}

export function onDeleteEndDateForDatesIntervalEditor(
    editorId: string,
    onRemoveEndDate?: () => void,
    showMessage?: boolean
): OnDeleteEndDateForDatesIntervalEditor {
    return {
        type: ON_DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR,
        editorId,
        onRemoveEndDate,
        showMessage
    };
}

export const UPDATE_DATES_INTERVAL_EDITORS = 'UPDATE_DATES_INTERVAL_EDITORS';
export type UPDATE_DATES_INTERVAL_EDITORS = typeof UPDATE_DATES_INTERVAL_EDITORS;

export interface UpdateDatesIntervalEditors {
    type: UPDATE_DATES_INTERVAL_EDITORS;
    editors: DatesIntervalEditorsState;
}

export function updateDatesIntervalEditors(editors: DatesIntervalEditorsState): UpdateDatesIntervalEditors {
    return {
        type: UPDATE_DATES_INTERVAL_EDITORS,
        editors
    };
}

export type DatesIntervalEditorAction =
    | ChangeStartDateForDatesIntervalEditor
    | ChangeEndDateForDatesIntervalEditor
    | ChangeStartTimeForDatesIntervalEditor
    | ChangeEndTimeForDatesIntervalEditor
    | AddEndDateForDatesIntervalEditor
    | OnDeleteEndDateForDatesIntervalEditor
    | DeleteEndDateForDatesIntervalEditor
    | UpdateDatesIntervalEditors;
